import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const subheading = "Why Choose Us";
const heading = "Why V9 Prime Force Pvt. Ltd. Stands Out";
const paragraph =
  "We deliver more than just manpower — we offer strategic HR solutions with speed, ethics, and commitment. Whether you're a startup or an enterprise, our transparent process ensures quality hires, fast.";

const features = [
  { title: "Industry Expertise", desc: "Tailored recruitment strategies for each sector." },
  { title: "Transparent Process", desc: "Ethical, clear, and compliant recruitment workflows." },
  { title: "Quick Turnaround", desc: "Rapid hiring without compromising quality." },
  { title: "Scalable HR Support", desc: "Solutions that grow with your business needs." },
  { title: "End-to-End Ownership", desc: "From sourcing to onboarding, we manage it all." },
];

const splitWords = (text) => text.split(" ").map((word, i) => ({ word, key: i }));

const WhyChooseUsSection = () => {
  const textRef = useRef(null);
  const isInView = useInView(textRef, { once: true, margin: "-100px" });

  return (
    <div className="why-choose-us-wrapper-v9">
      {/* Left Column - Feature Cards */}
      <div className="why-choose-us-cards-v9">
        {features.map((feature, index) => (
          <div key={index} className="why-choose-us-card-v9">
            <h3>{feature.title}</h3>
            <p>{feature.desc}</p>
          </div>
        ))}
      </div>

      {/* Right Column - Animated Text */}
      <motion.div
        className="why-choose-us-text-v9"
        ref={textRef}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={{
          visible: {
            transition: {
              staggerChildren: 0.06,
            },
          },
        }}
      >
        {/* Subheading */}
        <motion.p className="why-choose-us-subheading-v9">
          {splitWords(subheading).map(({ word, key }) => (
            <motion.span
              key={`sub-${key}`}
              className="why-choose-word-v9"
              variants={{
                hidden: { opacity: 0, y: 10 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              {word}&nbsp;
            </motion.span>
          ))}
        </motion.p>

        {/* Heading */}
        <motion.h2 className="why-choose-us-heading-v9">
          {splitWords(heading).map(({ word, key }) => (
            <motion.span
              key={`head-${key}`}
              className="why-choose-word-v9"
              variants={{
                hidden: { opacity: 0, y: 15 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              {word}&nbsp;
            </motion.span>
          ))}
        </motion.h2>

        {/* Paragraph */}
        <motion.p className="why-choose-us-paragraph-v9">
          {splitWords(paragraph).map(({ word, key }) => (
            <motion.span
              key={`para-${key}`}
              className="why-choose-word-v9"
              variants={{
                hidden: { opacity: 0, y: 15 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              {word}&nbsp;
            </motion.span>
          ))}
        </motion.p>
      </motion.div>
    </div>
  );
};

export default WhyChooseUsSection;
